import { generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from '../axiosConfig';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { ECOM_OTP_SEND } from '@/configs/ecom/apis';
import is from '@/utils/is';

export const otpSend = async (body: { mobile_number: string; email?: string }): Promise<any> => {
  try {
    if (is.client() && window.webengage && window.webengage.track) {
      window.webengage.track('direct_OTP_SEND', body);
    }
    return await axiosInstance.post(generateBFFUrl(ECOM_OTP_SEND), body);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
